<script setup>
function toApply() {
  window.open(
    'https://cdn.isc.360.com/iscvideo-bucket/ISC2023_2023_Sponsor_Plan_0522.pdf',
    '_self '
  )
}
</script>

<template>
  <div class="membership">
    <img src="https://p0.ssl.qhimg.com/t01d4e9d864bef9f527.jpg" alt="" class="membershipBgc" />
    <div class="membershipNav">
      <img src="https://p0.ssl.qhimg.com/t014b570ecda2fc846d.jpg" alt="内容" />
      <div class="membershipBtn" @click="toApply">点击下载商务合作方案</div>
      <div class="membershipText">
        <p>ISC商务总监：马欣15718876610</p>
        <p>获取早鸟折扣 重磅权益提前锁定！</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.membership {
  position: relative;
  height: 100vh;
  &Bgc {
    position: fixed;
    top: 0;
    min-width: 375px;
    width: 100vw;
  }
  &Nav {
    width: 100vw;
    min-width: 375px;
    text-align: center;
    background-color: #fff;
    position: absolute;
    top: 168px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
  }
  &Btn {
    cursor: pointer;
    width: 157px;
    height: 26px;
    line-height: 26px;
    font-size: 7px;
    margin: 10px auto 16px;
    color: #fff;
    font-weight: bold;
    background: #1833ff;
    box-shadow: 0px 1px 4px 0px rgba(24, 127, 255, 0.5);
    border-radius: 13px;
  }
  &Text {
    color: #1b1b1b;
    line-height: 22px;
    margin: 0 auto 115px;
    p:first-child {
      font-size: 15px;
    }
    p:last-child {
      font-size: 7px;
    }
  }
}
</style>
